import { renderTopbar } from '../components/topbar.js';
import { renderCalendarHistory } from '../components/calendarHistory.js';
import { getSchoolQuizLog } from '../lib/quizScore.js';
import { friendlyError } from '../lib/friendlyError.js';

// "Scores" (#/school/scores) — a school owner's calendar of every quiz
// attempt by any of its currently-linked students, across every course
// (self-authored, remix-subscribed, or view-only marketplace-subscribed —
// see functions/quizScores.js getSchoolQuizLog for why all three show up
// here). Each day's detail groups by course, then student.
export function renderSchoolScores(container) {
  container.innerHTML = '';
  container.appendChild(renderTopbar('/school/scores'));

  const main = document.createElement('div');
  main.className = 'main-full';
  main.innerHTML = `<div class="empty-state">Loading scores…</div>`;
  container.appendChild(main);

  getSchoolQuizLog()
    .then((attempts) => {
      main.innerHTML = `
        <h1 style="margin-bottom:4px;">🗓️ Scores</h1>
        <p style="color:var(--text-dim);margin-top:0;">Every quiz your students have completed, by date.</p>
        ${attempts.length === 0
          ? '<div class="empty-state"><div style="font-size:2.5rem;">📊</div><h3>No quiz scores yet</h3><p>Scores will show up here once your students start completing quizzes.</p></div>'
          : '<div id="scores-calendar"></div>'}
      `;
      if (attempts.length > 0) {
        renderCalendarHistory(main.querySelector('#scores-calendar'), { attempts, groupByStudent: true });
      }
    })
    .catch((err) => {
      main.innerHTML = `<div class="empty-state"><p>${friendlyError(err, 'Could not load scores.')}</p></div>`;
    });

  return () => {};
}
